import { AccountLogin } from '../account/login/account-login';
import { CheckoutStep } from './checkout-step';

export const CheckoutLogin = () => {
  return (
    <CheckoutStep title="Authorization" step={1}>
      <AccountLogin redirect="/cart/checkout" isAsync />
    </CheckoutStep>
  );
};
